import { state } from "@src/state";
export const selectPolls = () => state.meeting.poll.polls;
export const selectActivePoll = () => state.meeting.poll.activePoll;
export const selectActivePollTime = () => state.meeting.poll.activePollTime;
